/** True inside device-preview iframe (?embed=1). */
export function useEmbedPreview() {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("embed") === "1";
}

/** Skip enter animations in embed iframe — hidden iframes freeze at opacity: 0. */
export function embedMotionProps(isEmbed, props) {
  if (!isEmbed) return props;

  const next = { ...props };

  if (next.whileInView && !next.animate) {
    next.animate = next.whileInView;
  }
  if (!next.animate) {
    next.animate = { opacity: 1, y: 0, scale: 1 };
  }

  delete next.whileInView;
  delete next.viewport;
  delete next.transition;
  next.initial = false;

  return next;
}
